export default __webpack_public_path__ + "static/share-information-65fe96292decdcc15470692b63bbdd21.png";